module.exports = __webpack_public_path__ + "ba16ea966f7a314b919b23def81074a3.jpg";